import { Camera } from './Camera';
import { Checkbox } from './Checkbox';
import { DateInput } from './DateInput';
import { Device } from './Device';
import { FaceScale } from './FaceScale';
import { GenScale } from './GenScale';
import { HeightInput } from './HeightInput';
import { Medicine } from './Medicine';
import { MultiNumInput } from './MultiNumInput';
import { NumInput } from './NumInput';
import { Picker } from './Picker';
import { RadioBtn } from './RadioBtn';
import { Text } from './Text';
import { WeightInput } from './WeightInput';

export function QuestionType({
  answers,
  getAnswer,
  index,
  medicineHistory,
  questions,
}) {
  if (!questions[index].answers) {
    return <div />;
  }

  const key = questions[index].id;

  const answerHistory = answers[questions[index].id];

  const data = questions[index].answers.map((a, i) => ({
    key: i.toString(),
    text: a.text?.trim(),
    options: a.options,
  }));

  const NumInputType = () => {
    switch (questions[index].options.unit) {
      case 'height':
        return (
          <HeightInput
            key={key}
            answerHistory={answerHistory}
            sendAnswer={(value) => getAnswer(value)}
            options={questions[index].options}
          />
        );

      case 'weight':
        return (
          <WeightInput
            key={key}
            answerHistory={answerHistory}
            sendAnswer={(value) => getAnswer(value)}
            options={questions[index].options}
          />
        );

      default:
        return (
          <NumInput
            key={key}
            answerHistory={answerHistory}
            sendAnswer={(value) => getAnswer(value)}
            options={questions[index].options}
          />
        );
    }
  };

  switch (questions[index].type) {
    case 'boolean':
    case 'radio':
    case 'scale':
      return (
        <RadioBtn
          key={key}
          data={data}
          answerHistory={answerHistory}
          sendAnswer={(value) => getAnswer(value)}
          options={questions[index].options}
        />
      );

    case 'camera':
      return (
        <Camera
          key={key}
          answerHistory={answerHistory}
          sendAnswer={(value) => getAnswer(value)}
          questionId={questions[index].id}
        />
      );

    case 'checkbox':
      return (
        <Checkbox
          key={key}
          data={data}
          answerHistory={answerHistory}
          sendAnswer={(value) => getAnswer(value)}
          options={questions[index].options}
        />
      );

    case 'date':
      return (
        <DateInput
          key={key}
          answerHistory={answerHistory}
          sendAnswer={(value) => getAnswer(value)}
        />
      );

    case 'device':
      return <Device sendAnswer={(value) => getAnswer(value)} />;

    case 'face_scale':
      return (
        <FaceScale
          key={key}
          answerHistory={answerHistory}
          sendAnswer={(value) => getAnswer(value)}
        />
      );

    case 'gen_scale':
      return (
        <GenScale
          key={key}
          data={data}
          answerHistory={answerHistory}
          sendAnswer={(value) => getAnswer(value)}
          options={questions[index].options}
        />
      );

    case 'medicine':
      return (
        <Medicine
          key={key}
          data={data}
          answerHistory={answerHistory}
          medicineHistory={medicineHistory}
          sendAnswer={(value) => getAnswer(value)}
        />
      );

    case 'multiple_numerical_input':
      return (
        <MultiNumInput
          answerHistory={answerHistory}
          data={data}
          sendAnswer={(value) => getAnswer(value)}
          options={questions[index].options}
        />
      );

    case 'numerical_input':
      return NumInputType();

    case 'picker':
      return (
        <Picker
          key={key}
          data={data}
          answerHistory={answerHistory}
          sendAnswer={(value) => getAnswer(value)}
        />
      );

    case 'text':
      return (
        <Text
          key={key}
          answerHistory={answerHistory}
          sendAnswer={(value) => getAnswer(value)}
        />
      );

    default:
      return <div />;
  }
}
